import SalesOrderDocumentPage from "../../pages/legacy/SalesOrderDocumentPage";

const route = {
  key: "salesorder.detail",
  path: "/legacy/sales-orders/:dataAreaId/:id",
  component: SalesOrderDocumentPage,
  private: true,
  layout: "main",
  icon: "faFileInvoice",
  group: "sales",
  order: 21.01,
  permission: "legacy.salesorder.read"
};

export default route;